import { gql } from "@apollo/client";
import StripePriceFragment from "../fragments/StripePrice.fragment";
import StripeProductFragment from "../fragments/StripeProduct.fragment";

export const GET_PRODUCTS = gql`
  query getStripeProducts {
    getStripeProducts {
      product {
        ...StripeProduct
      }
      prices {
        ...StripePrice
      }
    }
  }
  ${StripeProductFragment.fragment}
  ${StripePriceFragment.fragment}
`;

export default GET_PRODUCTS;
